export const affiliateGeneratedLeadRoute = () => 'order/generatedLeads';
export const affiliateConvertedLeadRoute = () => 'order/convertedLeads';
